
import { MultiString } from "../../i18n/MultiString";
import { Message } from "../../messages/Message";
import { MessageType, MessageTypes } from "../../messages/MessageType";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { DataType } from "./DataType";

export class MessageReference
{
  node:RJExpressionNode;
  messageIndex:number;
  context:string;
}

export class EvaluationResult<T>
{
  success:boolean;
  data:T;
  type:DataType;

  messageReferences:MessageReference[] = [];
  messages:Message[] = [];

  toString()
  {
    let json:any = 
    {
      success: this.success,
      messsages: this.messages
    }

    return JSON.stringify( json );
  }

  static withValue<T>( value:T, type:DataType )
  {
    let result = new EvaluationResult<T>();
    result.success = true;
    result.data = value;
    result.type = type;

    return result;
  }  

  static withMessage( source:RJExpressionNode, type:MessageType, messageContent:string|MultiString, success:boolean = true )
  {
    let result = new EvaluationResult<any>();
    result.success = success;
    result.messages.push( Message.with( type, MultiString.resolve( messageContent ) ) );

    let reference = new MessageReference();
    reference.node = source;
    reference.messageIndex = result.messages.length - 1;
    result.messageReferences.push( reference );
    return result;
  } 

  static asError( source:RJExpressionNode, messageContent:string|MultiString )
  {
    return this.withMessage( source, MessageTypes.Error, messageContent, false );
  }
}